import { GeneralValueObject } from './general-value-object';

export class Region extends GeneralValueObject {}

export const EtelaRegion = new Region('south', 'Etelä-Suomi');
export const KeskiRegion = new Region('central', 'Keski-Suomi');
export const PohjoisRegion = new Region('north', 'Pohjois-Suomi');
export const Regions = [EtelaRegion, KeskiRegion, PohjoisRegion];
